export default "__VITE_ASSET__CPbtin4D__"